import React, { useContext, useEffect, useState } from "react";
import { IMAGES, SVG_IMAGES } from "../../assets";
import { APP_BUNDLES } from "../../../app_constant";
import { USER_DEAFULT_KEY } from "../../constant/event";
import { ThemeContext } from "../../context/ThemeProvider";
import { useNavigate } from "react-router-dom";
import { BundleContext } from "../../context/BundleProvider";
import { auth } from "../../api/config";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimes, 
  faExchangeAlt, 
  faCheck,
  faSpinner
} from '@fortawesome/free-solid-svg-icons';

const ChangeExam = (props) => {
  const { theme, currentTheme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { selectedCertificate, setSelectedBundle } = useContext(BundleContext);
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const loadBundles = async () => {
      try {
        const bundlesData = await APP_BUNDLES;
        setBundles(bundlesData);
        if (props.isFirst) {
          setSelected(bundlesData[0]?.key);
        } else {
          setSelected(selectedCertificate);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error loading bundles:', error);
        setLoading(false);
      }
    };
    loadBundles();
  }, []);

  const [userDetail, setUserDetail] = useState({});
  const [selected, setSelected] = useState(null);

  // Helper function to get icon background color
  const getIconBg = () => {
    return currentTheme === 'light' ? theme?.primary?.light : theme?.primary?.dark;
  }

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  const onChangeBundle = async (certificateName) => {
    if (certificateName === selectedCertificate) {
      props.onCancle();
      return;
    }
    if (selected) {
      localStorage.setItem(
        USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS,
        certificateName
      );
      await setSelectedBundle(certificateName);
      props.onPress(certificateName);

      if (props.isFirst) {
        window.location.reload();
      } else {
        setTimeout(async () => {
          navigate("/prepare", {
            state: {
              firstName: userDetail?.firstName ?? "",
              isFromOnboarding: false,
              isFromLoginSignup: false,
              loginSignupType: userDetail?.loginWay ?? "",
            },
          });
        }, 500);
      }
    } else {
      await setSelectedBundle(bundles[0].key);
      props.onCancle();

      setTimeout(async () => {
        window.location.reload();
      }, 1500);
    }
  };

  useEffect(() => {
    let authData = {
      id: auth().currentUser?.uid,
      UserName: auth()?.currentUser?.displayName ?? "",
      email: auth().currentUser.email,
      loginWay: auth().currentUser?.providerData[0]?.providerId ?? "",
      last_signin_time: auth().currentUser.metadata?.lastSignInTime ?? "",
    };
    setUserDetail(authData);
  }, []);

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        duration: 0.2,
        type: "spring",
        damping: 25,
        stiffness: 500
      }
    },
    exit: { 
      opacity: 0, 
      scale: 0.9,
      transition: { duration: 0.15 }
    }
  };

  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.2 } },
    exit: { opacity: 0, transition: { duration: 0.15 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: i => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.05,
        duration: 0.3
      }
    }),
    hover: {
      scale: 1.03,
      boxShadow: "0px 5px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }
  };

  if (loading) {
    return (
      <AnimatePresence>
        <motion.div
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={overlayVariants}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
        >
          <motion.div
            variants={modalVariants}
            className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-8 flex flex-col items-center"
          >
            <FontAwesomeIcon 
              icon={faSpinner} 
              className="text-4xl animate-spin mb-4"
              style={{ color: getIconBg() }}
            />
            <p 
              className="text-lg font-medium"
              style={{ color: getTextColor() }}
            >
              Loading...
            </p>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    );
  }

  return (
    <AnimatePresence>
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={overlayVariants}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      >
        <motion.div
          variants={modalVariants}
          className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-6 w-full max-w-md"
        >
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mr-4"
                style={{ backgroundColor: getIconBg() }}
              >
                <FontAwesomeIcon 
                  icon={faExchangeAlt} 
                  className="text-white text-xl" 
                />
              </div>
              <div>
                <h2 
                  className="text-xl font-semibold"
                  style={{ color: getTextColor() }}
                >
                  {props.title}
                </h2>
                <p 
                  className="text-gray-500 dark:text-gray-400 mt-1"
                >
                  {props.desc}
                </p>
              </div>
            </div>
            
            {!props?.hideCancle && (
              <button
                onClick={props?.onCancle}
                className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                <FontAwesomeIcon 
                  icon={faTimes} 
                  style={{ color: getTextColor() }}
                />
              </button>
            )}
          </div>

          {/* Exam Options */}
          <div className="space-y-3 my-6">
            {bundles?.map((ele, idx) => (
              <motion.button
                key={idx}
                custom={idx}
                variants={itemVariants}
                whileHover="hover"
                className="w-full rounded-xl p-4 flex items-center justify-between transition-colors"
                style={{ 
                  backgroundColor: ele?.THEME_DARK || '#3b82f6',
                  border: selected === ele?.key ? '2px solid white' : 'none'
                }}
                onClick={() => setSelected(ele?.key)}
              >
                <span className="text-white font-medium">
                  {ele?.title}
                </span>
                {selected === ele?.key && (
                  <div className="w-6 h-6 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                    <FontAwesomeIcon 
                      icon={faCheck} 
                      className="text-white text-sm" 
                    />
                  </div>
                )}
              </motion.button>
            ))}
          </div>

          {/* Action Button */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              onChangeBundle(selected);
              localStorage.setItem(
                USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS,
                selected
              );
              props.onCancle();
            }}
            className="w-full py-3 px-6 rounded-xl font-medium text-white mt-4"
            style={{ backgroundColor: getIconBg() }}
          >
            Continue
          </motion.button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ChangeExam;  